import React from 'react';
import { useTranslation } from 'react-i18next';
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import styles from './ButtonsStyles.module.scss';
import { botAiProvider } from '../ChatBotAI';

export const SetWidthChatButton = () => {
  const { t } = useTranslation();

  return (
    <button
      onClick={() => botAiProvider.toggleWindowHalfScreen()}
      className={styles.SetWidthChatButton}
      title={t('cartAI.toggleHalfScreen')}
    >
      <AspectRatioIcon />
    </button>
  );
};
